import Swiper from '../Swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFRightArrow from '@/components/UI/svg/CSR/Icons/EFArrowRight';
import { createEFPic } from '@/utils/useEFPic';
import EFVideo from '@/components/UI/EFVideo';

const { EFPic } = createEFPic('/img/csr/pc/');

export default function B(): JSX.Element {
    const { useLang, useEffect, useState, Link } = useGlobal();
    const { t } = useLang('csr');

    // tab宽度
    const itemWidth = 840;
    // 间隔宽度
    const gap = 40;

    const locationList = [
        {
            title: t('secH_dItem3_title'),
            description: [t('secH_list3_desc1')],
            // video: ['/video/csr/2.mp4', '/video/csr/2.mp4'],
            icon: ['h-3.jpg', 'h-3.jpg'],
            imgLink: 'https://youtu.be/sGzDEKQEqag',
            // link: {
            //     text: t('secH_interview'),
            //     href: 'https://prtimes.jp/main/html/rd/p/000000071.000050601.html',
            // },
        },
        {
            title: t('secH_dItem1_title'),
            personInfo: t('secH_dItem1_address'),
            subTitle: t('secH_dItem1_profile'),
            description: [t('secH_list1_desc1'), t('secH_list1_desc2'), t('secH_list1_desc3'), t('secH_list1_desc4')],
            icon: ['h-1.webp', 'h-1.jpg'],
            link: {
                text: t('secH_interview'),
                href: 'https://blog.ecoflow.com/jp/experiencing-power-outage/',
            },
        },
        {
            title: t('secH_dItem2_title'),
            description: [
                t('secH_list2_desc1'),
                t('secH_list2_desc2'),
                t('secH_list2_desc3'),
                t('secH_list2_desc4'),
                t('secH_list2_desc5'),
                t('secH_list2_desc6'),
            ],
            icon: ['h-2.webp', 'h-2.jpg'],
            link: {
                text: t('secH_interview'),
                href: 'https://prtimes.jp/main/html/rd/p/000000071.000050601.html',
            },
        },
    ];

    useEffect(() => {
        const ScrollMagic = (window as any).ScrollMagic;
        const controller = new ScrollMagic.Controller();

        const scene = new ScrollMagic.Scene({
            triggerElement: '.csrHSwiperBox',
            triggerHook: 1,
            offset: 100,
        }).setClassToggle('.csrHSwiperBox', 'show');

        const titleScene = new ScrollMagic.Scene({
            triggerElement: '.csrTitle',
            triggerHook: 1,
            offset: 100,
        }).setClassToggle('.csr_pc_H .csrTitle', 'enter');

        controller.addScene(scene);
        controller.addScene(titleScene);
    }, []);

    const letters: [string] = t('secH_title').split('');

    return (
        <div className={`csr_pc_H ${css.csr_pc_H}`}>
            <div className="container">
                <div className="csrTitle">
                    {letters.map((letter, index) => (
                        <span key={index} className={`letter_h letter_${index}`}>
                            {letter}
                        </span>
                    ))}
                </div>
            </div>
            <Swiper itemWidth={itemWidth} gap={gap} itemNum={locationList?.length} className="csrHSwiperBox" isRightAlign={false} isStepByStep={true}>
                {locationList.map((item: any) => (
                    <div
                        key={item.title}
                        className="listItem"
                        style={{
                            width: `${itemWidth}px`,
                            marginRight: `${gap}px`,
                        }}
                    >
                        {item?.icon && !item?.imgLink && <EFPic className="listItemImg" name={[`${item.icon[0]}`, `${item.icon[1]}`]} />}
                        {item?.icon && item?.imgLink && (
                            <Link className="listImgLink" href={item?.imgLink}>
                                <EFPic className="listItemImg" name={[`${item.icon[0]}`, `${item.icon[1]}`]} />
                            </Link>
                        )}
                        {item?.video && <EFVideo className="listItemImg" width="270px" height="400px" sources={item.video} aria-label={item.title} />}
                        <div className="listItemInfoBox">
                            <div>
                                <div className="h-title">{item.title}</div>
                                {item?.personInfo && <div className="personInfo">{item.personInfo}</div>}
                            </div>
                            <div>
                                {item?.subTitle && <div className="h-subTitle">{item.subTitle}</div>}
                                <div className="h-desc_box">
                                    {item.description.map((descItem: any, k: number) => (
                                        <div className="h-desc" key={k}>
                                            {descItem}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {item?.link && (
                                <Link className="h-link" href={item?.link?.href || '/'}>
                                    <div className="linkText">{item?.link?.text}</div>
                                    <div className="linkIcon">
                                        <EFRightArrow stroke={'#03060b'} />
                                    </div>
                                </Link>
                            )}
                        </div>
                    </div>
                ))}
            </Swiper>
        </div>
    );
}
